import React from 'react';
import PageHero from '../components/PageHero';
import CtaSection from '../components/CtaSection';
import AnswerReceipt from '../components/AnswerReceipt';
import { Rail, RuledRows, Section, SectionHead } from '../components/System';
import useSeo from '../lib/useSeo';

const FEATURES = [
  { title: 'Fast answers', detail: 'Text appears as it is written. No waiting.' },
  { title: 'Charts included', detail: 'The right chart, next to the answer.' },
  { title: 'Nothing lost', detail: 'Every question and answer is saved.' },
  { title: 'Working shown', detail: 'See the calculation beside the answer.' },
];

function ConversationalBI() {
  useSeo({
    title: 'Conversational BI for Financial Data',
    path: '/conversational-bi',
    description: 'Ask a financial question in plain English and get the answer, a chart, and how it was worked out. Conversational BI with a receipt for every answer.',
  });

  return (
    <main className="relative w-full">
      <PageHero
        image="boardroom"
        eyebrow="Conversational BI Chat"
        title="Ask anything. Check every answer."
        subtitle="Type a question. Get the answer, a chart, and how it was worked out."
        badge="Pick a question below"
        primary={{ label: 'Request a demo', to: '/#request-briefing' }}
      />

      <Section tone="stone" className="lg:pt-[calc(clamp(56px,6vw,88px)+64px)]">
        <div className="shell">
          <SectionHead layout="statement" label="Try a question" title="Three questions. One method." aside="Pick one. See the answer and how it was worked out." />
          <div className="mt-12 lg:mt-16">
            <AnswerReceipt variant="wide" />
          </div>
        </div>
      </Section>

      <Section tone="white">
        <div className="shell">
          <Rail label="What you get" title="Built for real questions." aside="Fast, visual, and always checkable.">
            <RuledRows items={FEATURES} />
          </Rail>
        </div>
      </Section>

      <CtaSection
        image="between"
        eyebrow="Get Started"
        title="Ask your own."
        subtitle="Connect your data. Ask what matters."
        primary={{ label: 'Request a demo', to: '/#request-briefing' }}
        secondary={{ label: 'Back to Overview', to: '/' }}
      />
    </main>
  );
}

export default ConversationalBI;
